import i18n from '@/lang/index'
// 导出配置的路由器
export default [{
  path: '/possessionCenter',
  component: () => import('@/layout/index'),
  redirect: 'possessionCenter/orderManager',
  meta: {title: i18n.t('cai-wu-zhong-xin'), icon: 'icon-shouru2', perms: ['bee:possession']},
  children: [
    {
      path: 'incomeView',
      component: () => import('@/module/possessionCenter/page/incomeView.vue'),
      meta: {title: i18n.t('shou-ru-zong-lan-zong-jian-kong-ban'), icon: 'icon-zhangdan', perms: ['bee:order:screenAll']}
    },
    {
      path: 'operatorIncomeView',
      component: () => import('@/module/possessionCenter/page/operatorIncomeView.vue'),
      meta: {title: i18n.t('shou-ru-zong-lan-yun-ying-shang-ban'), icon: 'icon-zhangdan', perms: ['bee:order:screenOperator']}
    },
    {
      path: 'orderManager',
      component: () => import('@/module/possessionCenter/page/order/manage.vue'),
      meta: {title: i18n.t('ding-dan-guan-li'), icon: 'icon-order', perms: ['bee:possession:order']}
    },
    {
      path: 'orderHistoryManager',
      component: () => import('@/module/possessionCenter/page/chargingHistoryManager.vue'),
      meta: {title: i18n.t('ding-dan-li-shi-guan-li-0'), icon: 'icon-order', perms: ['bee:possession:order']}
    },
    {
      path: 'settleManager',
      component: () => import('@/module/possessionCenter/page/settle/manage.vue'),
      meta: {title: i18n.t('jie-suan-dan-guan-li'), icon: 'icon-zhangdan', perms: ['bee:possession:settle']}
    },
    {
      path: 'groupBill',
      component: () => import('@/module/possessionCenter/page/groupBill/manage.vue'),
      meta: {title: i18n.t('ji-tuan-zhang-dan'), icon: 'icon-jituan2', perms: ['bee:possession:groupOrder']}
    },
    {
      path: 'interactiveOrder',
      component: () => import('@/module/possessionCenter/page/cecOrder/manage.vue'),
      meta: {title: i18n.t('hu-lian-hu-tong-ding-dan'), icon: 'icon-zhangdan1', perms: ['bee:possession:cecOrder']}
    },
    {
      path: 'invoiceManager',
      component: () => import('@/module/possessionCenter/page/invoiceManager.vue'),
      meta: {title: i18n.t('fa-piao-guan-li'), icon: 'icon-fapiao1', perms: ['bee:order:invoice']}
    },

    {
      path: 'billManager',
      component: () => import('@/module/possessionCenter/page/statement/billManager.vue'),
      meta: {title: i18n.t('dui-zhang-dan-guan-li'), icon: 'icon-zhangdan',perms: ['bee:order:bill']}
    }
    ,
    {
      path: 'cmd202Manager',
      component: () => import('@/module/possessionCenter/page/chargingMessage202Manager.vue'),
      meta: {title: i18n.t('cmd202-chong-dian-guan-li'), icon: 'icon-zhangdan',perms: ['bee:order:cmd202']}
    }
    // {
    //   path: 'simRenewManager',
    //   component: () => import('@/module/possessionCenter/page/simRenewManager.vue'),
    //   meta: {title: 'sim卡支付管理', icon: 'icon-fapiao1', perms: ['bee:order:invoice']}
    // }
  ]
}]



// WEBPACK FOOTER //
// ./src/module/possessionCenter/router/index.js